// Copied from transition-web/src/libs/SignInMachine.tsx
// TODO: Adapt for new structure and implement missing functions

import invariant from 'invariant'
import moment from 'dayjs'
import { createUniqueId } from '../../../pure-js/libs/Common'
import { SignInState, SignInSteps } from '../../../pure-js/types/SignInTypes'
import { State } from '../hooks/useAppState'
import { signInWithCustomToken } from './FirebaseHelper'
import { DEFAULT_SIGN_IN_STATE } from './SignInHelper'

import { createAuthenticationTokenForLoginToken, createLoginWithCodeToken } from './authCloudFunctions'

const toBaseObject = ({ user: { id: userId } }: State, id = createUniqueId(), now = moment().format()) => ({
  id,
  createdAt: now,
  createdBy: userId
})

export const onPressContinue = (
  signInState: SignInState,
  state: State,
  _e: {
    navigate: (path: string) => void
  },
  f = {
    createLoginWithCodeToken,
    signInWithCustomToken,
    createAuthenticationTokenForLoginToken
  }
): Promise<SignInState> =>
  Promise.resolve().then(async () => {
    switch (signInState.step) {
      case SignInSteps.LANDING: {
        const { email } = signInState.data
        invariant(email, '!email')
        const loginToken = await f.createLoginWithCodeToken(
          {
            email,
            ...toBaseObject(state)
          },
          state
        )
        signInState.data.loginToken = loginToken
        return { ...signInState, step: SignInSteps.ENTER_CODE }
      }
      case SignInSteps.ENTER_CODE: {
        const { code, loginToken } = signInState.data
        invariant(code, '!code')
        invariant(loginToken, '!loginToken')

        const createAuthenticationTokenForLoginTokenResponse = await f.createAuthenticationTokenForLoginToken(
          { ...loginToken, code },
          state
        )

        // Check if the response indicates success and has a token
        if (
          !createAuthenticationTokenForLoginTokenResponse.success ||
          !createAuthenticationTokenForLoginTokenResponse.token
        ) {
          // Throw an error for invalid code
          throw new Error('Invalid verification code. Please try again.')
        }

        await f.signInWithCustomToken(createAuthenticationTokenForLoginTokenResponse.token)

        return DEFAULT_SIGN_IN_STATE
      }
      default:
        return signInState
    }
  })
